import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-keyframe-linear-large.tsx
/**
* icon.24.keyframe-linear.large
*
* Keywords: diamond, shape, geometric, rhombus, rotate, orientation, outline
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyIDNhMSAxIDAgMCAxIC43MDcuMjkzbDcuOTk4IDcuOTk4YTEgMSAwIDAgMSAwIDEuNDE0bC03Ljk5OCA3Ljk5OGExIDEgMCAwIDEtMS40MTQgMGwtNy45OTgtNy45OThhMSAxIDAgMCAxIDAtMS40MTRsNy45OTgtNy45OTguMDc0LS4wNjZBMSAxIDAgMCAxIDEyIDNtLTcuOTk4IDguOTk4TDEyIDE5Ljk5Nmw3Ljk5OC03Ljk5OEwxMiA0eiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26677-58967
*/
const Icon24KeyframeLinearLarge = memo(function Icon24KeyframeLinearLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12 3a1 1 0 0 1 .707.293l7.998 7.998a1 1 0 0 1 0 1.414l-7.998 7.998a1 1 0 0 1-1.414 0l-7.998-7.998a1 1 0 0 1 0-1.414l7.998-7.998.074-.066A1 1 0 0 1 12 3m-7.998 8.998L12 19.996l7.998-7.998L12 4z"
		})
	});
});
//#endregion
export { Icon24KeyframeLinearLarge };

//# sourceMappingURL=icon-24-keyframe-linear-large.js.map